import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/app/max/home/HomeClient.tsx");
